import { Box, styled } from '@mui/material'

export const StyledAccordionGroup = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  '&.wrapped': {
    '.accordion-wrapper': {
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      '.MuiAccordion-root': {
        '&::before': {
          display: 'none !important',
        },
      },
      '.MuiAccordionSummary-root': {
        fontFamily: theme.typography.fontFamily,
        padding: theme.spacing(.5, 0),
        marginBottom: theme.spacing(1),
        borderBottom: `1px solid black`,
      },
    },
  },
  '&:not(.wrapped)': {
    '.MuiAccordion-root': {
    },
  },

  '.group-header': {
    '.MuiButtonBase-root': {
      color: theme.palette.tertiary.main,
      paddingRight: theme.spacing(0),
    },
    svg: {
      color: theme.palette.tertiary.main,
      strokeWidth: .5
    }
  },
  '.MuiAccordion-root': {
    marginBottom: theme.spacing(1),
    svg: {
      color: theme.palette.tertiary.main,
      fontSize: '2rem',
    },
    '.MuiAccordionSummary-root': {
      color: theme.palette.tertiary.main,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: '1.125rem',
      minHeight: '2rem',
      padding: 0,
      
      '.MuiAccordionSummary-content': {
        margin: 0,
      },
    },
    '.MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  [theme.breakpoints.up('md')]: {
    '.MuiAccordion-root': {
      marginBottom: theme.spacing(3),
    },
  },
}))
